/* eslint-disable @typescript-eslint/explicit-function-return-type */
import type {GetNotificationConfigurationResourceTypeDto} from '@cohort/admin-schemas/notification';
import {useCohortQuery} from '@cohort/merchants/hooks/api/Query';
import {getNotificationConfigurations} from '@cohort/merchants/lib/api/Notifications';
import type {EventId} from '@cohort/shared/schema/apps';

export const notificationConfigurationsKeys = {
  notificationConfigurations: ['notificationConfigurations'] as const,
  list: (merchantId: string) =>
    [...notificationConfigurationsKeys.notificationConfigurations, merchantId] as const,
  listWithResourceTypes: (
    merchantId: string,
    resourceTypes: Array<GetNotificationConfigurationResourceTypeDto>,
    resourceId?: string
  ) => [...notificationConfigurationsKeys.list(merchantId), resourceTypes, resourceId] as const,
};

export const useNotificationConfigurationsWithResourceTypes = (
  merchantId: string,
  userEventIds: Array<EventId>,
  resourceTypes: Array<GetNotificationConfigurationResourceTypeDto>,
  resourceId?: string,
  enabled?: boolean
) =>
  useCohortQuery({
    queryKey: notificationConfigurationsKeys.listWithResourceTypes(
      merchantId,
      resourceTypes,
      resourceId
    ),
    queryFn: async () => {
      return getNotificationConfigurations(merchantId, {
        userEventIds,
        resourceTypes,
        resourceId,
      });
    },
    enabled,
  });
